<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="mt-2">
      Segmentación
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="reload()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">
            Familias
            <v-icon>mdi-family-tree</v-icon>
          </v-tab>
          <v-tab href="#tab-2">
            Categorías
            <v-icon>mdi-tag</v-icon>
          </v-tab>
          <v-tab href="#tab-3">
            Subcategorías
            <v-icon>mdi-tag-outline</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat class="pa-4" style="background-color: white;">
          <h2 class="text-center mb-4">Familias</h2>
          <!-- Buscar -->
          <GeneralFilter
            entity="lista"
            :filterEndpoint="$API.itemtypes.getFamiliesFiltered"
            :search="{ name: search, includePrinter: 'true' }"
            @emptyFilter="getFamilies"
            @filtered="filterHandlerFamilies"
            clearable
            :hideLimitLabel="true"
          ></GeneralFilter>
          <!-- Formulario Agregar/Editar -->
          <v-row class="mb-4">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="familyName"
                :label="editing ? 'Editar Nombre de Familia' : 'Nombre de Familia'"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-if="useprinters === 1"
                v-model="selectedPrinterIdFamily"
                :items="printers"
                item-text="Name"
                item-value="ID_Printer"
                label="Impresora"
                outlined
                dense
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                class="btn-save"
                @click="editing ? updateFamily() : addFamily()"
                :disabled="!familyName"
              >
                {{ editing ? 'Actualizar' : 'Agregar' }} Familia
              </v-btn>
              <v-btn v-if="editing" class="ml-2" @click="cancelEdit">Cancelar</v-btn>
            </v-col>
          </v-row>
          <!-- Tabla -->
          <v-data-table
            :headers="familyHeaders"
            :items="families"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.printer="{ item }" v-if="useprinters === 1">
              {{ getPrinterName(item.ID_Printer) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="startEdit(item)">mdi-pencil</v-icon>
              <v-icon small color="error" @click="confirmDelete(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>
          <div class="d-flex justify-center mt-1 mb-2">
            <p>En la prevista se muestras los últimos 100 registros agregados</p>
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat class="pa-4" style="background-color: white;">
          <h2 class="text-center mb-4">Categorías</h2>
          <!-- Selector de Familia -->
          <v-select
            v-model="selectedFamily"
            :items="allFamilies"
            item-text="name"
            item-value="id"
            label="Seleccionar Familia"
            outlined
            dense
            class="mb-4"
            @change="loadCategories"
          ></v-select>
          <!-- Buscar -->
          <GeneralFilter
            entity="categoria"
            :filterEndpoint="$API.itemtypes.getCategoriesFiltered"
            :search="{ name: searchCategory, id_family: selectedFamily, includePrinter: 'true' }"
            @emptyFilter="loadCategories"
            @filtered="filterHandlerCategories"
            v-if="selectedFamily"
            clearable
            :hideLimitLabel="true"
          ></GeneralFilter>
          <!-- Formulario Agregar/Editar -->
          <v-row class="mb-4" v-if="selectedFamily">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="categoryName"
                :label="editingCategory ? 'Editar Nombre de Categoría' : 'Nombre de Categoría'"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-if="useprinters === 1"
                v-model="selectedPrinterIdCategory"
                :items="printers"
                item-text="Name"
                item-value="ID_Printer"
                label="Impresora"
                outlined
                dense
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                class="btn-save"
                @click="editingCategory ? updateCategory() : addCategory()"
                :disabled="!categoryName"
              >
                {{ editingCategory ? 'Actualizar' : 'Agregar' }} Categoría
              </v-btn>
              <v-btn v-if="editingCategory" class="ml-2" @click="cancelEditCategory">Cancelar</v-btn>
            </v-col>
          </v-row>
          <!-- Tabla -->
          <v-data-table
            v-if="selectedFamily"
            :headers="categoryHeaders"
            :items="categories"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.printer="{ item }" v-if="useprinters === 1">
              {{ getPrinterName(item.ID_Printer) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="startEditCategory(item)">mdi-pencil</v-icon>
              <v-icon small color="error" @click="confirmDeleteCategory(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>
          <div v-if="selectedFamily" class="d-flex justify-center mt-1 mb-2">
            <p>En la prevista se muestras los últimos 100 registros agregados</p>
          </div>
          <p v-else>Seleccione una familia para ver las categorías.</p>
          <!-- Overlay de carga -->
          <v-overlay :value="loadingCategories">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-3">
        <v-card flat class="pa-4" style="background-color: white;">
          <h2 class="text-center mb-4">Subcategorías</h2>
          <!-- Selector de Categoría -->
          <v-select
            v-model="selectedCategory"
            :items="allCategories"
            item-text="name"
            item-value="id"
            label="Seleccionar Categoría"
            outlined
            dense
            class="mb-4"
            @change="loadSubcategories"
          ></v-select>
          <!-- Buscar -->
          <GeneralFilter
            entity="lista"
            :filterEndpoint="$API.itemtypes.getSubsFiltered"
            :search="{ name: searchSubcategory, id_cat: selectedCategory, includePrinter: 'true' }"
            @emptyFilter="loadSubcategories"
            @filtered="filterHandlerSubs"
            v-if="selectedCategory"
            clearable
            :hideLimitLabel="true"
          ></GeneralFilter>
          <!-- Formulario Agregar/Editar -->
          <v-row class="mb-4" v-if="selectedCategory">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="subcategoryName"
                :label="editingSubcategory ? 'Editar Nombre de Subcategoría' : 'Nombre de Subcategoría'"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-if="useprinters === 1"
                v-model="selectedPrinterIdSubcategory"
                :items="printers"
                item-text="Name"
                item-value="ID_Printer"
                label="Impresora"
                outlined
                dense
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                class="btn-save"
                @click="editingSubcategory ? updateSubcategory() : addSubcategory()"
                :disabled="!subcategoryName"
              >
                {{ editingSubcategory ? 'Actualizar' : 'Agregar' }} Subcategoría
              </v-btn>
              <v-btn v-if="editingSubcategory" class="ml-2" @click="cancelEditSubcategory">Cancelar</v-btn>
            </v-col>
          </v-row>
          <!-- Tabla -->
          <v-data-table
            v-if="selectedCategory"
            :headers="subcategoryHeaders"
            :items="subcategories"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.printer="{ item }" v-if="useprinters === 1">
              {{ getPrinterName(item.ID_Printer) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="startEditSubcategory(item)">mdi-pencil</v-icon>
              <v-icon small color="error" @click="confirmDeleteSubcategory(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>
          <div v-if="selectedCategory" class="d-flex justify-center mt-1 mb-2">
            <p>En la prevista se muestras los últimos 100 registros agregados</p>
          </div>
          <p v-else>Seleccione una categoría para ver las subcategorías.</p>
          <!-- Overlay de carga -->
          <v-overlay :value="loadingSubcategories">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <!-- Alertas -->
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import alerts from '@/components/Alerts.vue';
import GeneralFilter from "@/components/GeneralFilter";

export default {
  name: 'Segmentation',
  components: {
    alerts,
    GeneralFilter
  },
  props: {
    win: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tab: 'tab-1',
      families: [],
      allFamilies: [],
      search: '',
      familyName: '',
      editing: false,
      editItem: null,
      selectedPrinterIdFamily: null,
      selectedFamily: null,
      categories: [],
      allCategories: [],
      searchCategory: '',
      categoryName: '',
      editingCategory: false,
      editCategoryItem: null,
      selectedPrinterIdCategory: null,
      selectedCategory: null,
      subcategories: [],
      searchSubcategory: '',
      subcategoryName: '',
      editingSubcategory: false,
      editSubcategoryItem: null,
      selectedPrinterIdSubcategory: null,
      loadingCategories: false,
      loadingSubcategories: false,
      useprinters: 0,
      printers: [],
      toDelete: null,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
        options: null
      }
    }
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log('User object:', user);
    this.useprinters = user?.useprinters || 0;
    
    this.getFamilies();
    this.getAllFamilies();
    this.getCategories();
    this.getAllCategories();
    
    if (this.useprinters === 1) {
      this.loadPrinters();
    }
  },
  computed: {
    filteredFamilies() {
      if (!this.search) return this.families;
      return this.families.filter(family =>
        family.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    filteredCategories() {
      if (!this.searchCategory) return this.categories;
      return this.categories.filter(category =>
        category.name.toLowerCase().includes(this.searchCategory.toLowerCase())
      );
    },
    filteredSubcategories() {
      if (!this.searchSubcategory) return this.subcategories;
      return this.subcategories.filter(subcategory =>
        subcategory.name.toLowerCase().includes(this.searchSubcategory.toLowerCase())
      );
    },
    familyHeaders() {
      const headers = [
        { text: 'Nombre', value: 'name' }
      ];
      if (this.useprinters === 1) {
        headers.push({ text: 'Impresora', value: 'printer', sortable: false });
      }
      headers.push({ text: 'Acciones', value: 'actions', sortable: false });
      return headers;
    },
    categoryHeaders() {
      const headers = [
        { text: 'Nombre', value: 'name' }
      ];
      if (this.useprinters === 1) {
        headers.push({ text: 'Impresora', value: 'printer', sortable: false });
      }
      headers.push({ text: 'Acciones', value: 'actions', sortable: false });
      return headers;
    },
    subcategoryHeaders() {
      const headers = [
        { text: 'Nombre', value: 'name' }
      ];
      if (this.useprinters === 1) {
        headers.push({ text: 'Impresora', value: 'printer', sortable: false });
      }
      headers.push({ text: 'Acciones', value: 'actions', sortable: false });
      return headers;
    }
  },
  methods: {
    reload() {
      this.getFamilies();
      this.getAllFamilies();
      this.getCategories();
      this.getAllCategories();
      this.selectedFamily = null;
      this.categories = [];
      this.selectedCategory = null;
      this.subcategories = [];
      this.search = '';
      this.searchCategory = '';
      this.searchSubcategory = '';
      this.familyName = '';
      this.categoryName = '';
      this.subcategoryName = '';
      this.editing = false;
      this.editingCategory = false;
      this.editingSubcategory = false;
      this.editItem = null;
      this.editCategoryItem = null;
      this.editSubcategoryItem = null;
    },
    getFamilies() {
      this.$API.itemtypes.getFamiliesHistory({ includePrinter: 'true' }).then((response) => {
        this.families = response;
        console.log('Families data received:', response);
      }).catch((error) => {
        console.error('Error al obtener familias:', error);
      });
    },
    getAllFamilies() {
      this.$API.itemtypes.getFamiliesHistory().then((response) => {
        this.allFamilies = response;
        console.log('All families data received:', response);
      }).catch((error) => {
        console.error('Error al obtener todas las familias:', error);
      });
    },
    getCategories() {
      this.$API.itemtypes.getCategoriesHistory().then((response) => {
        this.categories = response;
      }).catch((error) => {
        console.error('Error al obtener categorías:', error);
      });
    },
    getAllCategories() {
      this.$API.itemtypes.getCategoriesHistory().then((response) => {
        this.allCategories = response;
      }).catch((error) => {
        console.error('Error al obtener todas las categorías:', error);
      });
    },
    async loadPrinters() {
      try {
        const response = await this.$API.printers.getPrinters();
        this.printers = response.data || response;
        console.log('Printers structure:', this.printers);
        console.log('First printer keys:', this.printers.length > 0 ? Object.keys(this.printers[0]) : 'No printers');
      } catch (error) {
        console.error('Error al cargar impresoras:', error);
        this.showAlert("error", "Error", "No se pudieron cargar las impresoras");
      }
    },
    getPrinterName(printerId) {
      if (!printerId || !this.printers.length) return 'Sin asignar';
      console.log('Searching printer with id:', printerId);
      const printer = this.printers.find(p => p.ID_Printer === printerId);
      console.log('Found printer:', printer);
      return printer ? printer.Name : 'Sin asignar';
    },
    filterHandlerFamilies(response) {
      this.families = response;
    },
    filterHandlerCategories(response) {
      this.categories = response;
    },
    filterHandlerSubs(response) {
      this.subcategories = response;
    },
    addFamily() {
      if (!this.familyName) return;
      this.$API.itemtypes.createFam({ name: this.familyName, ID_Printer: this.selectedPrinterIdFamily || null }).then(() => {
        this.familyName = '';
        this.selectedPrinterIdFamily = null;
        this.getFamilies();
        this.getAllFamilies();
        this.showAlert("success", "Éxito", "La familia se agregó correctamente");
      }).catch((error) => {
        console.error('Error al agregar familia:', error);
        this.showAlert("error", "Error", "No se pudo agregar la familia");
      });
    },
    startEdit(item) {
      this.editing = true;
      this.editItem = item;
      this.familyName = item.name;
      this.selectedPrinterIdFamily = item.ID_Printer;
    },
    updateFamily() {
      if (!this.familyName || !this.editItem) return;
      // Asumiendo que hay una API updateFam; si no, adaptar
      console.log("PRINTER: " + this.selectedPrinterIdFamily)
      this.$API.itemtypes.updateFam({ 
        id: this.editItem.id, 
        name: this.familyName, 
        ID_Printer: this.selectedPrinterIdFamily,
        ID_ItemPrinter: this.editItem.ID_ItemPrinter || null
      }).then(() => {
        this.cancelEdit();
        this.getFamilies();
        this.getAllFamilies();
        this.showAlert("success", "Éxito", "La familia se actualizó correctamente");
      }).catch((error) => {
        console.error('Error al actualizar familia:', error);
        this.showAlert("error", "Error", "No se pudo actualizar la familia");
      });
    },
    cancelEdit() {
      this.editing = false;
      this.editItem = null;
      this.familyName = '';
      this.selectedPrinterIdFamily = null;
    },
    confirmDelete(id) {
      this.showAlert("question", "Eliminar Familia", "¿Está seguro que desea eliminar esta familia?", "deleteFamily");
      this.toDelete = id;
    },
    deleteFamily(id) {
      this.$API.itemtypes.deleteFam(id).then(() => {
        this.getFamilies();
        this.getAllFamilies();
        this.showAlert("success", "Éxito", "La familia se eliminó correctamente");
      }).catch((error) => {
        console.error('Error al eliminar familia:', error);
        this.showAlert("error", "Error", "No se pudo eliminar la familia");
      });
    },
    showAlert(type, header, body, options = null) {
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options;
    },
    closeAlert() {
      this.alert.show = false;
    },
    loadCategories() {
      if (this.selectedFamily) {
        this.loadingCategories = true;
        this.$API.itemtypes.getCategoriesByFamily({ id_family: this.selectedFamily, includePrinter: 'true' }).then((response) => {
          this.categories = response;
        }).catch((error) => {
          console.error('Error al obtener categorías:', error);
        }).finally(() => {
          this.loadingCategories = false;
        });
      } else {
        this.categories = [];
      }
      this.selectedCategory = null;
      this.subcategories = [];
    },
    addCategory() {
      if (!this.categoryName || !this.selectedFamily) return;
      this.$API.itemtypes.createCat({ name: this.categoryName, id_family: this.selectedFamily, ID_Printer: this.selectedPrinterIdCategory || null }).then(() => {
        this.categoryName = '';
        this.selectedPrinterIdCategory = null;
        this.loadCategories();
        this.getAllCategories();
        this.showAlert("success", "Éxito", "La categoría se agregó correctamente");
      }).catch((error) => {
        console.error('Error al agregar categoría:', error);
        this.showAlert("error", "Error", "No se pudo agregar la categoría");
      });
    },
    startEditCategory(item) {
      this.editingCategory = true;
      this.editCategoryItem = item;
      this.categoryName = item.name;
      this.selectedPrinterIdCategory = item.ID_Printer;
    },
    updateCategory() {
      if (!this.categoryName || !this.editCategoryItem) return;
      this.$API.itemtypes.updateCat({ 
        id: this.editCategoryItem.id, 
        name: this.categoryName, 
        ID_Printer: this.selectedPrinterIdCategory || null,
        ID_ItemPrinter: this.editCategoryItem.ID_ItemPrinter || null
      }).then(() => {
        this.cancelEditCategory();
        this.loadCategories();
        this.getAllCategories();
        this.showAlert("success", "Éxito", "La categoría se actualizó correctamente");
      }).catch((error) => {
        console.error('Error al actualizar categoría:', error);
        this.showAlert("error", "Error", "No se pudo actualizar la categoría");
      });
    },
    cancelEditCategory() {
      this.editingCategory = false;
      this.editCategoryItem = null;
      this.categoryName = '';
      this.selectedPrinterIdCategory = null;
    },
    confirmDeleteCategory(id) {
      this.showAlert("question", "Eliminar Categoría", "¿Está seguro que desea eliminar esta categoría?", "deleteCategory");
      this.toDelete = id;
    },
    deleteCategory(id) {
      this.$API.itemtypes.deleteCat(id).then(() => {
        this.loadCategories();
        this.getAllCategories();
        this.showAlert("success", "Éxito", "La categoría se eliminó correctamente");
      }).catch((error) => {
        console.error('Error al eliminar categoría:', error);
        this.showAlert("error", "Error", "No se pudo eliminar la categoría");
      });
    },
    loadSubcategories() {
      if (this.selectedCategory) {
        this.loadingSubcategories = true;
        this.$API.itemtypes.getSubsByCategory({ id_cat: this.selectedCategory, includePrinter: 'true' }).then((response) => {
          this.subcategories = response;
        }).catch((error) => {
          console.error('Error al obtener subcategorías:', error);
        }).finally(() => {
          this.loadingSubcategories = false;
        });
      } else {
        this.subcategories = [];
      }
    },
    addSubcategory() {
      if (!this.subcategoryName || !this.selectedCategory) return;
      this.$API.itemtypes.createSub({ name: this.subcategoryName, id_cat: this.selectedCategory, ID_Printer: this.selectedPrinterIdSubcategory || null }).then(() => {
        this.subcategoryName = '';
        this.selectedPrinterIdSubcategory = null;
        this.loadSubcategories();
        this.showAlert("success", "Éxito", "La subcategoría se agregó correctamente");
      }).catch((error) => {
        console.error('Error al agregar subcategoría:', error);
        this.showAlert("error", "Error", "No se pudo agregar la subcategoría");
      });
    },
    startEditSubcategory(item) {
      this.editingSubcategory = true;
      this.editSubcategoryItem = item;
      this.subcategoryName = item.name;
      this.selectedPrinterIdSubcategory = item.ID_Printer;
    },
    updateSubcategory() {
      if (!this.subcategoryName || !this.editSubcategoryItem) return;
      this.$API.itemtypes.updateSub({ 
        id: this.editSubcategoryItem.id, 
        name: this.subcategoryName, 
        ID_Printer: this.selectedPrinterIdSubcategory || null,
        ID_ItemPrinter: this.editSubcategoryItem.ID_ItemPrinter || null
      }).then(() => {
        this.cancelEditSubcategory();
        this.loadSubcategories();
        this.showAlert("success", "Éxito", "La subcategoría se actualizó correctamente");
      }).catch((error) => {
        console.error('Error al actualizar subcategoría:', error);
        this.showAlert("error", "Error", "No se pudo actualizar la subcategoría");
      });
    },
    cancelEditSubcategory() {
      this.editingSubcategory = false;
      this.editSubcategoryItem = null;
      this.subcategoryName = '';
      this.selectedPrinterIdSubcategory = null;
    },
    confirmDeleteSubcategory(id) {
      this.showAlert("question", "Eliminar Subcategoría", "¿Está seguro que desea eliminar esta subcategoría?", "deleteSubcategory");
      this.toDelete = id;
    },
    deleteSubcategory(id) {
      this.$API.itemtypes.deleteSub(id).then(() => {
        this.loadSubcategories();
        this.showAlert("success", "Éxito", "La subcategoría se eliminó correctamente");
      }).catch((error) => {
        console.error('Error al eliminar subcategoría:', error);
        this.showAlert("error", "Error", "No se pudo eliminar la subcategoría");
      });
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.alert.options === "deleteFamily") {
        this.deleteFamily(this.toDelete);
      } else if (this.alert.options === "deleteCategory") {
        this.deleteCategory(this.toDelete);
      } else if (this.alert.options === "deleteSubcategory") {
        this.deleteSubcategory(this.toDelete);
      }
    }
  }
}
</script>

<style scoped>
</style>